import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getActiveEvents, getEventByGuid } from '../../api/eventsService';
import SocialShare from '../../components/SocialShare/SocialShare';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
const DEFAULT_IMAGE = '/assets/images/example-post.webp';

function EventsDetail() {
  const { urlTag } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const fetchEventDetails = async () => {
      if (!urlTag) {
        navigate('/etkinlikler');
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        // Önce urlTag'e sahip etkinliği bulmak için tüm aktif etkinlikleri çekelim
        const activeEventsResponse = await getActiveEvents(1, 100);
        if (!activeEventsResponse.isSuccess) {
          throw new Error('Etkinlikler yüklenemedi');
        }

        // urlTag'e sahip etkinliği bulalım
        const targetEvent = activeEventsResponse.data.items.find(event => event.urlTag === urlTag);
        if (!targetEvent) {
          throw new Error('Etkinlik bulunamadı');
        }

        // Şimdi guid ile etkinlik detaylarını çekelim
        const response = await getEventByGuid(targetEvent.guid);
        if (response.isSuccess && response.data) {
          setEvent(response.data);
          setError(null);
        } else {
          throw new Error(response.resultMessage || 'Etkinlik detayları yüklenemedi');
        }
      } catch (error) {
        console.error('Error in fetchEventDetails:', error);
        setError(error.message || 'Etkinlik yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [urlTag, navigate]);

  useEffect(() => {
    let redirectTimer;
    if (error && !loading) {
      redirectTimer = setTimeout(() => {
        navigate('/etkinlikler');
      }, 3000);
    }
    return () => redirectTimer && clearTimeout(redirectTimer);
  }, [error, loading, navigate]);

  const handleImageError = (e) => {
    console.log('Image failed to load, using default image');
    e.target.src = DEFAULT_IMAGE;
  };

  if (loading) {
    return (
      <div className="events-detail">
        <div className="container py-5">
          <div className="text-center">
            <div className="loading">Yükleniyor...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="events-detail">
        <div className="container py-5">
          <div className="text-center">
            <div className="alert alert-warning" role="alert">
              {error}
            </div>
            <p>Etkinlikler sayfasına yönlendiriliyorsunuz...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!event) {
    return null;
  }

  const eventDate = new Date(event.date);
  const formattedDate = eventDate.toLocaleDateString('tr-TR');
  const formattedTime = eventDate.toLocaleTimeString('tr-TR', { 
    hour: '2-digit', 
    minute: '2-digit' 
  });

  return (
    <div className="events-detail">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          <div className="col-md-10">
          <div className="row">
          <div className="col-md-6">
            <img 
              src={event.pictureUrl || DEFAULT_IMAGE} 
              alt={event.header} 
              className="img-fluid rounded event-img"
              onClick={() => setIsOpen(true)}
              onError={handleImageError}
            />
            <Lightbox
              open={isOpen}
              close={() => setIsOpen(false)}
              slides={[
                { src: event.pictureUrl || DEFAULT_IMAGE }
              ]}
            />
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-12">
                <h1 className="events-detail-title mb-4">{event.header}</h1>
                <div className="events-detail-meta mb-4">
                  <div className="meta-box">
                    <div className="meta-box-title">
                      <span>Tarih:</span>
                    </div>
                    <div className="meta-box-info">
                      <span>{formattedDate}</span>
                    </div>
                  </div>
                  <div className="meta-box">
                    <div className="meta-box-title">
                      <span>Saat:</span>
                    </div>
                    <div className="meta-box-info">
                      <span>{formattedTime}</span>
                    </div>
                  </div>
                  <div className="meta-box">
                    <div className="meta-box-title">
                      <span>Yer:</span>
                    </div>
                    <div className="meta-box-info location">
                      <span>{event.location}</span>
                      {event.mapLocationCode && (
                        <a href={event.mapLocationCode} target="_blank" rel="noopener noreferrer">Yol Tarifi Al</a>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mini-description alert alert-info mb-3">
                  <p className="mb-0">{event.shortDetail}</p>
                </div>
              
                <div className="events-detail-content">
                  <p className="lead mb-4">{event.detail}</p>
                
                </div>
              
              </div>
            </div>
            <div className="events-detail-footer">
              <div className="events-detail-footer__left">
                <SocialShare />
              </div>
              <div className="events-detail-footer__right">
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
     
      </div>
    </div>
  );
}

export default EventsDetail;
